import { render, staticRenderFns } from "./mCardHeader.vue?vue&type=template&id=6c1d3cf4&scoped=true"
import script from "./mCardHeader.vue?vue&type=script&lang=ts"
export * from "./mCardHeader.vue?vue&type=script&lang=ts"
import style0 from "./mCardHeader.vue?vue&type=style&index=0&id=6c1d3cf4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1d3cf4",
  null
  
)

export default component.exports